import { Component, ViewChild, ElementRef, HostListener } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { BehaviorSubject, Subject } from 'rxjs';
import { UserProfileService } from './user-profile.service';
import moment from 'moment';
import { ToastrService } from 'ngx-toastr';
import { BsDatepickerDirective } from 'ngx-bootstrap/datepicker';
import { NavigationStart, Router } from '@angular/router';
import { SharedService } from '../../shared/shared.service';

@Component({
    selector: 'app-user-profile',
    templateUrl: './user-profile.component.html',
    styleUrls: ['./user-profile.component.scss'],
    standalone: false
})
export class UserProfileComponent {
	@ViewChild('fileInput', { static: false }) fileInput!: ElementRef;
	submitted: boolean = false;
	showUploadPopup = false;
	newPhoto: string | null = null; // Track new uploaded photo
	userForm: FormGroup;
	isLoading: Subject<boolean> = new Subject<boolean>();
	maxDate: any = new Date();
	@ViewChild(BsDatepickerDirective, { static: false }) datepicker?: BsDatepickerDirective;

	@HostListener('window:scroll')
	onScrollEvent() {
		this.datepicker?.hide();
	}
	public previousUrl: any = '';
	constructor(private fb: FormBuilder, private userService: UserProfileService, private toastr: ToastrService, private router: Router, private sharedService: SharedService) {
		this.userForm = this.fb.group({
			employeeId: [''],
			firstName: [''],
			lastName: [''],
			dob: [''],
			email: [''],
			mobileNumber: ['', [Validators.required, Validators.pattern('^[6-9][0-9]{9}$')]],
			role: [''],
			state: [''],
			district: [''],
			location: [''],
		})

		this.router.events
			.subscribe((event: any) => {
				if (event instanceof NavigationStart) {
					sessionStorage.setItem('previousUrl', this.router.url)
				}
			});
	}
	get f() { return this.userForm.controls; }

	ngOnInit() {
		if (sessionStorage.getItem('previousUrl')) {
			this.previousUrl = sessionStorage.getItem('previousUrl')
			const selectedItem = document.getElementById(this.previousUrl.split('/')[2]);
			if (selectedItem) {
				selectedItem.classList.add('active');
			}
		}
		this.getStateList();
		this.getUser();
	}

	onSubmit(): void {
		this.submitted = true;
		if (!this.userForm.valid) {
			return;
		} else {
			this.isLoading = new BehaviorSubject<boolean>(true);
			const formData = new FormData();
			formData.append("first_name", this.userForm.value.firstName);
			formData.append("last_name", this.userForm.value.lastName);
			formData.append("dob", moment(this.userForm.value.dob, 'DD-MM-YYYY').format('DD-MM-YYYY'));
			formData.append("state_id", this.userForm.value.state ? this.userForm.value.state : '');
			formData.append("district_id", this.userForm.value.district ? this.userForm.value.district : '');
			formData.append("location_id", this.userForm.value.location ? this.userForm.value.location : '');
			formData.append("mobile", this.userForm.value.mobileNumber);
			// formData.append("employee_id", this.userForm.value.employeeId);
			if (this.selectedImgFile != null) {
				formData.append("avatar", this.selectedImgFile);
			}
			this.userService.updateProfile(formData).subscribe((response: any) => {
				if (response.body.responseCode === 200) {
					this.isLoading = new BehaviorSubject<boolean>(false);
					this.toastr.success(response.body.responseMessage)
					this.submitted = false;
					this.clearForm();
					this.getUser();
				} else {
					this.isLoading = new BehaviorSubject<boolean>(false);
					this.toastr.error(response.body.responseMessage)
				}
			}, (error: any) => {
				this.isLoading = new BehaviorSubject<boolean>(false);
			})
		}
	}

	stateList: any = [];
	districtList: any = [];
	locationList: any = [];
	clearForm() {
		this.districtList = [];
		this.locationList = [];
		this.userForm.patchValue({
			lastName: '',
			mobileNumber: '',
			state: '',
			district: '',
			location: ''
		})
	}

	openUploadPopup() {
		this.showUploadPopup = true;
	}

	closeUploadPopup() {
		this.showUploadPopup = false;
	}

	triggerFileInput() {
		this.fileInput.nativeElement.click();
	}

	selectedImgFile: any = null
	onFileSelected(event: any) {
		const file = event.target.files[0];
		this.selectedImgFile = file;
		if (file) {
			const reader = new FileReader();
			reader.onload = (e: any) => {
				this.newPhoto = e.target.result;
			};
			reader.readAsDataURL(file);
		}
	}

	confirmPhoto() {
		if (this.newPhoto) {
			this.closeUploadPopup();
		}
	}

	onDragOver(event: DragEvent) {
		event.preventDefault();
		event.stopPropagation();
		(event.currentTarget as HTMLElement).classList.add('drag-over');
	}

	onDragLeave(event: DragEvent) {
		event.preventDefault();
		event.stopPropagation();
		(event.currentTarget as HTMLElement).classList.remove('drag-over');
	}

	onDrop(event: DragEvent) {
		event.preventDefault();
		event.stopPropagation();
		(event.currentTarget as HTMLElement).classList.remove('drag-over');
		const files = event.dataTransfer?.files;
		if (files && files.length > 0) {
			const file = files[0];
			this.selectedImgFile = file;
			const reader = new FileReader();
			reader.onload = (e: any) => {
				this.newPhoto = e.target.result;
			};
			reader.readAsDataURL(file);
		}
	}

	userData: any = {};
	getUser() {
		this.isLoading.next(true);
		this.userService.getUser().subscribe((response: any) => {
			if (response.body.responseCode == 200) {
				this.userData = response.body.data;
				this.getDistrict(this.userData.state?.id)
				this.getLocation(this.userData.district?.id)
				this.userForm.patchValue({
					// employeeId: this.userData.employee_id ? this.userData.employee_id : '',
					firstName: this.userData.first_name,
					lastName: this.userData.last_name ? this.userData.last_name : '',
					dob: this.userData.dob,
					email: this.userData.email,
					mobileNumber: this.userData.mobile,
					role: this.userData.role?.role,
					state: this.userData.state?.id ? this.userData.state?.id : '',
					district: this.userData.district?.id ? this.userData.district?.id : '',
					location: this.userData.location?.id ? this.userData.location?.id : ''
				})
				if (this.userData.avatar.includes("user.png")) {
					this.newPhoto = null
				} else {
					this.newPhoto = this.userData.avatar
				}
				this.isLoading.next(false);
			} else {
				this.isLoading.next(false);
			}
		}, (error: any) => {
			this.isLoading.next(false);
		});
	}

	deletePicture() {
		if (this.userData.avatar.includes('user.png')) {
			this.newPhoto = null;
			this.selectedImgFile = null;
		} else {
			this.userService.removePhoto().subscribe((response: any) => {
				let responseData = response.body
				if (responseData.responseCode == 200) {
					this.toastr.success(responseData.responseMessage)
					this.newPhoto = null;
					this.selectedImgFile = null;
					this.getUser();
				} else {
					this.toastr.error(responseData.responseMessage)
				}
			}, (err: any) => {
				this.isLoading = new BehaviorSubject<boolean>(false);
			});
		}
	}

	getStateList() {
		this.stateList = [];
		this.userService.getStateByCountry(1).subscribe((response: any) => {
			let responseData = response.body
			if (responseData.responseCode == 200) {
				this.stateList = responseData.data
			}
		}, (err: any) => {
			this.isLoading = new BehaviorSubject<boolean>(false);
		});
	}

	getDistrict(stateId?: any) {
		this.districtList = [];
		this.locationList = [];
		this.userForm.patchValue({
			district: '',
			location: ''
		})
		let id: any = this.userForm.value.state ? this.userForm.value.state : stateId
		this.userService.getDistrictsByState(id).subscribe((response: any) => {
			let responseData = response.body
			if (responseData.responseCode == 200) {
				this.districtList = responseData.data
			}
		}, (err: any) => {
			this.isLoading = new BehaviorSubject<boolean>(false);
		});
	}

	getLocation(stateId?: any) {
		this.locationList = [];
		let id: any = this.userForm.value.district ? this.userForm.value.district : stateId
		this.userService.getLocationsByDistrict(id).subscribe((response: any) => {
			let responseData = response.body
			if (responseData.responseCode == 200) {
				this.locationList = responseData.data
			}
		}, (err: any) => {
			this.isLoading = new BehaviorSubject<boolean>(false);
		});
	}

	allowNumbersOnly(event: any) {
		this.sharedService.allowNumbersOnly(event);
	}
}